module.exports = __webpack_public_path__ + "static/5News-c676d8b25f58fc1c0f86a8eb3ccf1454.jpg";